import { RootState } from "redux-store";

export const getGlobal = (state: RootState) => state?.global;
export const getNetworkState = (state: RootState) => state?.global?.isOnline;
export const getRouterPathname = (state: RootState) =>
  state?.router?.location?.pathname;
